import hasObjectPath from 'utils/objectsValidation/hasObjectPath';
interface inputObj {
	[key: string]: any;
}

export default function(obj: inputObj, path: string, defaultValue?: any): any {
	const paths = path.split('.');
	let lastVal = defaultValue;
	for (var i = 0; i < paths.length; i++) {
		if (hasObjectPath(obj, paths[i])) {
			lastVal = obj[paths[i]];
			obj = obj[paths[i]];
		} else {
			return defaultValue;
		}
	}
	return lastVal;
}
